import { graphql } from '~gql';

export const DELETE_ACCOUNT = graphql(`
  mutation DeleteAccount {
    deleteAccount {
      id
      deleteAt
    }
  }
`);
